
/*
Defines the custom element <ravel-pot>
*/

import { RavelPot } from './src/RavelPot.js';

customElements.define('ravel-pot', RavelPot);
